






























import Vue, { PropType } from 'vue'
import { assignTransferPopUp, getTopUpAgents } from '~/api/Topup/topup.api'
import Autocomplete from '~/components/Autocomplete.vue'
import CreateDialog from '~/components/CreateDialog.vue'
import IconButton from '~/components/IconButton.vue'
import { VueForm } from '~/utils/interfaces'
import { GetTopUpDTO } from '~/utils/interfaces/topup.interface'
import vRules from '~/utils/vRules'

export default Vue.extend({
  components: { IconButton, CreateDialog, Autocomplete },
  props: {
    item: {
      type: Object as PropType<GetTopUpDTO>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      model: false,
      agent: '',
      statuses: ['Success', 'Failed'].map(i => ({
        text: this.$t(i),
        value: i,
      })),
      vRules,
    }
  },
  methods: {
    async onSuccess() {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading = true
      try {
        await assignTransferPopUp(this.item.uuid, this.agent)

        this.$emit('refresh')
        this.model = false
      } finally {
        this.loading = false
      }
    },
    getTopUpAgents,
  },
})
